import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrivacyService {
  isDoNotTrackEnabled(): boolean {

    const dnt =
      navigator.doNotTrack ||
      (window as any).doNotTrack ||
      (navigator as any).msDoNotTrack;

    const gpc = (navigator as any).globalPrivacyControl === true;
    console.log('GPC:', gpc);
    console.log('DNT:', dnt, '→ doNotTrackEnabled:', (dnt === '1' || dnt === 'yes'));
    return (dnt === '1' || dnt === 'yes' || gpc);
  }
}
